import React from 'react';

const SCORE_LABELS = {
  1: 'Poor',
  2: 'Developing',
  3: 'Solid',
  4: 'Strong',
  5: 'Elite',
};

export default function ScoreBadge({ score, showLabel = false }) {
  if (score === null || score === undefined || score === '' || score === '-') {
    return <span className="text-xs text-muted-foreground px-2 py-0.5">-</span>;
  }
  const s = Math.round(Number(score));
  const cls = `score-${Math.max(1, Math.min(5, s))}`;
  const label = SCORE_LABELS[s] || '';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border tabular-nums ${cls}`}
    >
      {s}
      {showLabel && label && <span className="ml-1 hidden sm:inline">· {label}</span>}
    </span>
  );
}
